import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import AfterLoginTopbar from '../header/AfterLoginTopbar'
import {DeliveryListRequest, AcceptRejectRequest, GetEarningRequest} from '../../redux/reducer/FetchDataReducer'
import { useSelector, useDispatch } from 'react-redux'
import Loader from '../../utils/Loader'
import { toast } from 'react-toastify';
import { IMAGE } from '../../utils/Theme'

const Dashboard = () => {
  const [isshow, setisshow] = useState(true)
  const fetchReducer = useSelector((state) => state.FetchDataReducer)
 
  const dispatch = useDispatch()
   console.log("Dashboard",fetchReducer)

useEffect(()=>{

  let obj = {
    'status':'all'
  }

  dispatch(DeliveryListRequest(obj))

  dispatch(GetEarningRequest())

},[])


useEffect(()=>{
  
  let obj = {
    'status':'all'
  }
  dispatch(DeliveryListRequest(obj))

},[fetchReducer.acceptResponse])


const AcceptHandle = (uuid, status)=>{

  let obj= {
    "uuid": uuid,
    "status": status,
    "comment":status ? "I have accepted the order" : "I have rejected the order"
  }
  dispatch(AcceptRejectRequest(obj))
}

useEffect(()=>{
var totalLength = fetchReducer?.deliveryResponse?.data&&fetchReducer?.deliveryResponse?.data.length;
var arr = []
fetchReducer?.deliveryResponse?.data&&fetchReducer?.deliveryResponse?.data.forEach(element => {
  if(element.is_completed){
  return (
    arr.push(element)
  )
  }
});

var iscomplete = arr.length


if(totalLength == iscomplete){
  setisshow(false)
}

},[fetchReducer?.deliveryResponse])



  return (
    <>
      <AfterLoginTopbar
      title={`Welcome ${fetchReducer.profileResponse?.data?.first_name}`}
      acttion="menu"
      />
       <Loader visible={fetchReducer.isloading} />
      <div className='comon-body'>
          <div className='balance-d mb-3'>
              <NavLink to="/earning">
                  <div className='balance-d-card'>
                  <div className='balance-d-icon'>
                      <img src='images/Icon-2.png'/>
                  </div>
                  <div className='balance-d-info'>
                    <h5>Current Balance</h5>
                    <h4>$ {fetchReducer?.GetEarningResponse?.data?.total_earning}</h4>
                  </div>
                  <div className='balance-d-arrow'>
                  <i className="fa-solid fa-angle-right"></i>
                  </div>
                  </div>
              </NavLink>
          </div>
          <h3 className='page-title'>Assigned Orders</h3>
{isshow ?


          fetchReducer?.deliveryResponse?.data
&&fetchReducer?.deliveryResponse?.data.length > 0 ?
fetchReducer?.deliveryResponse?.data&&fetchReducer?.deliveryResponse?.data.map((item, index) =>{

  if(item?.status){
    if(!item?.is_completed)
    return (
      <div className='order-card' key={index}>
        <NavLink to={`/order-details/${item?.order?.uuid}`} >
      <div className='order-card-header'>
          <div className='order-card-header-sl'>
              {index + 1}
          </div>
          <div className='order-card-header-info'>
              <h5>Order: <span>{item?.order?.order_no
}</span></h5>
              <h5>Order Amt: <span>${item?.order?.total}</span></h5>
          </div>
      </div>
      <div className='order-card-body'>
          <div className='b-plist'>
              <span>
                  <img src={IMAGE.location}/>
              </span>
              <p>{item?.order?.address}</p>
          </div>
          <div className='b-plist'>
              <span>
                  <img src={IMAGE.user}/>
              </span>
              <p>Delivery To: {item?.order?.name}</p>
          </div>
          {!item?.status &&
              <ul>
                  <li>
                      <button className='reject-btn' onClick={()=>AcceptHandle(item?.order?.uuid, false)}>Reject</button>
                  </li>
                  <li>
                      <button className='accept-btn' onClick={()=>AcceptHandle(item?.order?.uuid, true)}>Accept</button>
                  </li>
              </ul>
}
      </div>
      </NavLink>
  </div>
    ) 
  } else {
    return (
      <div className='order-card' key={index}>
      
      <div className='order-card-header'>
          <div className='order-card-header-sl'>
              {index + 1}
          </div>
          <div className='order-card-header-info'>
              <h5>Order: <span>{item?.order?.order_no
}</span></h5>
              <h5>Order Amt: <span>${item?.order?.total}</span></h5>
          </div>
      </div>
      <div className='order-card-body'>
          <div className='b-plist'>
              <span>
                  <img src={IMAGE.location}/>
              </span>
              <p>{item?.order?.address}</p>
          </div>
          <div className='b-plist'>
              <span>
                  <img src={IMAGE.user}/>
              </span>
              <p>Delivery To: {item?.order?.name}</p>
          </div>
          {!item?.status &&
              <ul>
                  <li>
                      <button className='reject-btn' onClick={()=>AcceptHandle(item?.order?.uuid, false)}>Reject</button>
                  </li>
                  <li>
                      <button className='accept-btn' onClick={()=>AcceptHandle(item?.order?.uuid, true)}>Accept</button>
                  </li>
              </ul>
}
      </div>
    
  </div>
    )
  }

           
          }) 
        : 

        <h5>No Delivery List</h5>
        
        

        :
        <h5>No Delivery List</h5>

      }
         
      </div>
    </>
  )
}

export default Dashboard